"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Footer = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const modal_1 = require("@nbc-design/modal");
require("./dialog.css");
const Footer = ({ className, children, link }) => {
    return ((0, jsx_runtime_1.jsxs)(modal_1.Modal.Footer, { className: className, children: [(0, jsx_runtime_1.jsx)("div", { className: "dsc-dialog__footerChildren", children: children }), link && link] }));
};
exports.Footer = Footer;
//# sourceMappingURL=footer.js.map